export default __webpack_public_path__ + "static/insta-hotels-3-10a3d7d4f72f0e866265adabe995a562.jpg";